import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import en from "./../locales/en.json";
import hi from "./../locales/hi.json";
import od from "./../locales/od.json";
import bn from "./../locales/bn.json";
import ta from "./../locales/ta.json";

i18n
  .use(LanguageDetector) // Automatically detect browser language
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      hi: { translation: hi },
      od: { translation: od },
      bn: { translation: bn },
      ta: { translation: ta },
    },
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

export default i18n;
